"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regeneratePUSH = exports.regenerateOTP = exports.resendOTPLogin = void 0;
const resendOTPLogin = async (api, progressId) => {
    const url = `${window.MIDDLEWARE_AUTH_BASE_HOST}/authorization/otp/regenerate`;
    return api.POST(url, undefined, {
        headers: {
            progressId,
        },
    });
};
exports.resendOTPLogin = resendOTPLogin;
const regenerateOTP = (api, progressId) => api.POST(`${window.MIDDLEWARE_AUTH_SERVICE_HOST}/authorize/otp/regenerate`, undefined, {
    headers: {
        progressId,
    },
});
exports.regenerateOTP = regenerateOTP;
const regeneratePUSH = (api, progressId) => api.POST(`${window.MIDDLEWARE_AUTH_SERVICE_HOST}/authorize/biometric-trusted-confirmation/regenerate`, undefined, {
    headers: {
        progressId,
    },
});
exports.regeneratePUSH = regeneratePUSH;
//# sourceMappingURL=repository.js.map